// ABOUTME: Shared search-engine registry used by the search widget and the header search launcher.
// ABOUTME: Lets a launcher query that matches no link fall through to the web.

import { useUIStore } from "../stores/ui";

export interface SearchEngine {
  name: string;
  url: (query: string) => string;
}

export const SEARCH_ENGINES: SearchEngine[] = [
  { name: "DuckDuckGo", url: (q) => `https://duckduckgo.com/?q=${encodeURIComponent(q)}` },
  { name: "Google", url: (q) => `https://www.google.com/search?q=${encodeURIComponent(q)}` },
  { name: "ChatGPT", url: (q) => `https://chatgpt.com/?q=${encodeURIComponent(q)}` },
  { name: "Bing", url: (q) => `https://www.bing.com/search?q=${encodeURIComponent(q)}` },
  {
    name: "Gmail",
    url: (q) => `https://mail.google.com/mail/u/0/#search/${encodeURIComponent(q)}`,
  },
  {
    name: "Google Drive",
    url: (q) => `https://drive.google.com/drive/search?q=${encodeURIComponent(q)}`,
  },
];

/** Clamps a stored index to a real engine, falling back to the first entry. */
export function engineIndex(idx: unknown): number {
  return Number.isInteger(idx) && (idx as number) >= 0 && (idx as number) < SEARCH_ENGINES.length
    ? (idx as number)
    : 0;
}

/**
 * The user's chosen default engine. Read from the UI store, which the
 * per-user preferences document keeps in step across devices.
 */
export function preferredEngine(): SearchEngine {
  return SEARCH_ENGINES[engineIndex(useUIStore.getState().searchEngineIdx)];
}
